import { isNull, keys } from 'lodash';
// Import Constants
import { ErrorShowType, l, TemplateInputTypes } from 'constants/common';
// Import Services
import { TemplateSymbolsCountFields } from 'services/template';

const bodyScenario = (state) => ({
    isValid: null,
    errorText: '',
    value: '',
    paramValue: '',
    type: ErrorShowType.Default,
    validationCredentials: [
        {
            ValidationType: 'required',
            ErrorMessage: l.CannotBeEmpty,
            ParametersValues: null,
        },
        {
            ValidationType: 'maxLengthWithRegEx',
            ErrorMessage: l.MustContainMaximumBytes,
            ParametersValues: { ...state, fieldName: 'Body', count: TemplateSymbolsCountFields.Telegram },
        },
    ],
});

const imageURLPlaceholderDropdownScenario = () => {
    return {
        isValid: null,
        value: true,
        type: ErrorShowType.Default,
        errorText: '',
        paramValue: '',
        validationCredentials: [
            {
                ValidationType: 'required',
                ErrorMessage: l.ImageURLPlaceholderDropdownErrorText,
                ParametersValues: null,
            },
        ],
    };
};

const inlineKeyboardScenario = () => {
    return {
        isValid: null,
        errorText: '',
        value: '',
        paramValue: '',
        type: ErrorShowType.Toaster,
        validationCredentials: [
            {
                ValidationType: 'required',
                ErrorMessage: l.ButtonsRowError,
                ParametersValues: null,
            },
        ],
    };
};

const telegramTemplateValidationScenario = (state) => ({
    Name: {
        isValid: null,
        errorText: '',
        value: '',
        paramValue: '',
        type: ErrorShowType.Default,
        validationCredentials: [
            {
                ValidationType: 'required',
                ErrorMessage: l.CannotBeEmpty,
                ParametersValues: null,
            },
            {
                ValidationType: 'firstSymbol',
                ErrorMessage: l.NameFirstCharacterCantBeASymbol,
                ParametersValues: /^[\p{L}0-9]/gu,
            },
            {
                ValidationType: 'minLength',
                ErrorMessage: l.MustContainMinimumCharacters,
                ParametersValues: '3',
            },
            {
                ValidationType: 'maxLength',
                ErrorMessage: l.MustContainMaximumCharacters,
                ParametersValues: '50',
            },
        ],
    },
    Description: {
        isValid: null,
        errorText: '',
        value: '',
        paramValue: '',
        type: ErrorShowType.Default,
        validationCredentials: [
            {
                ValidationType: 'maxLength',
                ErrorMessage: l.MustContainMaximumCharacters,
                ParametersValues: '250',
            },
        ],
    },
    CrossValidation: {
        isValid: null,
        errorText: '',
        value: {},
        type: ErrorShowType.Toaster,
        validationCredentials: [
            {
                ValidationType: 'templateCrossValidation',
                ErrorMessage: '',
                ParametersValues: [TemplateInputTypes.Body],
            },
        ],
    },
    ForbiddenDynamicVariables: {
        isValid: null,
        errorText: '',
        value: {},
        type: ErrorShowType.Toaster,
        validationCredentials: [
            {
                ValidationType: 'templateForbiddenDynamicVariables',
                ErrorMessage: '',
                ParametersValues: [TemplateInputTypes.Body],
            },
        ],
    },
    [`defaultLang${TemplateInputTypes.InlineKeyboardFormikValidity}`]: {
        ...inlineKeyboardScenario(),
    },
    defaultLangBody: { ...bodyScenario(state) },
});

const telegramTemplateScenarioPropertiesCreater = (data, editCloneMode, state) => {
    if (editCloneMode) {
        return keys(data).reduce((acc, id) => {
            acc[`${id}Body`] = {
                ...bodyScenario(state),
                isValid: isNull(data[id].isValid) ? null : true,
                value: data[id].Body,
            };
            acc[`${id}${TemplateInputTypes.InlineKeyboardFormikValidity}`] = {
                ...inlineKeyboardScenario(),
                isValid: isNull(data[id].isValid) ? null : true,
                value: data[id][TemplateInputTypes.InlineKeyboardFormikValidity],
            };
            acc[`${id}${TemplateInputTypes.ImageURLPlaceholderDropdown}`] = {
                ...imageURLPlaceholderDropdownScenario(),
                isValid: isNull(data[id].isValid) ? null : true,
            };

            return acc;
        }, {});
    }
    return data.reduce((acc, id) => {
        acc[`${id}Body`] = { ...bodyScenario(state) };
        acc[`${id}${TemplateInputTypes.InlineKeyboardFormikValidity}`] = { ...inlineKeyboardScenario() };

        return acc;
    }, {});
};
export { telegramTemplateValidationScenario, telegramTemplateScenarioPropertiesCreater };
